/** A reason as typed, ended with one full stop: "Entered in error." never reads "Entered in error..". */
export function asSentence(s: string | null): string {
  const t = (s ?? '').trim();
  return /[.!?]$/.test(t) ? t : `${t}.`;
}
